import { useRef, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import WatchlistDetail from "./pages/WatchlistDetail";
import TVShowsPage from "./pages/TVShowsPage";
import FilmsPage from "./pages/FilmsPage";
import TVDiscoverPage from "./pages/TVDiscoverPage";
import FilmsDiscoverPage from "./pages/FilmsDiscoverPage";
import TVWatchedPage from "./pages/TVWatchedPage";
import FilmsWatchedPage from "./pages/FilmsWatchedPage";
import PodcastsPage from "./pages/PodcastsPage";
import PodcastDiscoverPage from "./pages/PodcastDiscoverPage";
import PodcastsListenedPage from "./pages/PodcastsListenedPage";
import PodcastListDetail from "./pages/PodcastListDetail";
import BooksPage from "./pages/BooksPage";
import BooksDiscoverPage from "./pages/BooksDiscoverPage";
import BooksReadPage from "./pages/BooksReadPage";
import BookListDetail from "./pages/BookListDetail";
import BooksRecommendationsPage from "./pages/BooksRecommendationsPage";
import ProfilePage from "./pages/ProfilePage";
import PublicProfilePage from "./pages/PublicProfilePage";
import ProfileSetup from "./pages/ProfileSetup";
import JoinListPage from "./pages/JoinListPage";
import AuthCallback from "./pages/AuthCallback";
import SocialPage from "./pages/SocialPage";
import MessagesPage from "./pages/MessagesPage";
import FriendContentPage from "./pages/FriendContentPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {/* Profile setup for first-time users */}
      <Route path="/profile-setup" element={
        <ProtectedRoute>
          <ProfileSetup />
        </ProtectedRoute>
      } />
      {/* Redirect /dashboard to /social */}
      <Route path="/dashboard" element={<Navigate to="/social" replace />} />
      {/* Social Page - Main feed */}
      <Route path="/social" element={
        <ProtectedRoute>
          <SocialPage />
        </ProtectedRoute>
      } />
      {/* Messages Page */}
      <Route path="/messages" element={
        <ProtectedRoute>
          <MessagesPage />
        </ProtectedRoute>
      } />
      <Route path="/messages/:userId" element={
        <ProtectedRoute>
          <MessagesPage />
        </ProtectedRoute>
      } />
      {/* Friend Content Page - view friend's lists and history */}
      <Route path="/friend/:friendId/content" element={
        <ProtectedRoute>
          <FriendContentPage />
        </ProtectedRoute>
      } />
      <Route path="/watchlist/:id" element={
        <ProtectedRoute>
          <WatchlistDetail />
        </ProtectedRoute>
      } />
      {/* Redirect old /watched to /tv-shows/watched */}
      <Route path="/watched" element={<Navigate to="/tv-shows/watched" replace />} />
      <Route path="/tv-shows" element={
        <ProtectedRoute>
          <TVShowsPage />
        </ProtectedRoute>
      } />
      <Route path="/tv-shows/watched" element={
        <ProtectedRoute>
          <TVWatchedPage />
        </ProtectedRoute>
      } />
      <Route path="/films" element={
        <ProtectedRoute>
          <FilmsPage />
        </ProtectedRoute>
      } />
      <Route path="/films/watched" element={
        <ProtectedRoute>
          <FilmsWatchedPage />
        </ProtectedRoute>
      } />
      <Route path="/discover/tv" element={
        <ProtectedRoute>
          <TVDiscoverPage />
        </ProtectedRoute>
      } />
      <Route path="/discover/films" element={
        <ProtectedRoute>
          <FilmsDiscoverPage />
        </ProtectedRoute>
      } />
      {/* Podcast Routes */}
      <Route path="/podcasts" element={
        <ProtectedRoute>
          <PodcastsPage />
        </ProtectedRoute>
      } />
      <Route path="/podcasts/listened" element={
        <ProtectedRoute>
          <PodcastsListenedPage />
        </ProtectedRoute>
      } />
      <Route path="/podcasts/list/:id" element={
        <ProtectedRoute>
          <PodcastListDetail />
        </ProtectedRoute>
      } />
      <Route path="/discover/podcasts" element={
        <ProtectedRoute>
          <PodcastDiscoverPage />
        </ProtectedRoute>
      } />
      {/* Book Routes */}
      <Route path="/books" element={
        <ProtectedRoute>
          <BooksPage />
        </ProtectedRoute>
      } />
      <Route path="/books-discover" element={
        <ProtectedRoute>
          <BooksDiscoverPage />
        </ProtectedRoute>
      } />
      <Route path="/books-read" element={
        <ProtectedRoute>
          <BooksReadPage />
        </ProtectedRoute>
      } />
      <Route path="/book-list/:id" element={
        <ProtectedRoute>
          <BookListDetail />
        </ProtectedRoute>
      } />
      <Route path="/books-recommendations" element={
        <ProtectedRoute>
          <BooksRecommendationsPage />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      } />
      <Route path="/profile/:userId" element={
        <ProtectedRoute>
          <PublicProfilePage />
        </ProtectedRoute>
      } />
      <Route path="/join/:shareCode" element={<JoinListPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <PWAInstallPrompt />
    </div>
  );
}

export default App;
